<app-input-header
  *ngIf="outsideLabel && labelValue"
  [labelKey]="labelValue"
  [required]="required"
  [reset]="default && default != value"
  (onReset)="reset()"
></app-input-header>
<mat-form-field
  appearance="outline"
  class="full-width background-white"
  [ngClass]="{ 'input-error': ngControl?.control?.touched && ngControl?.control?.errors }"
>
  <mat-label *ngIf="labelValue && !outsideLabel">{{ labelValue | locLabel }}</mat-label>
  <input
    #inputArea
    *ngIf="type !== 'textarea'"
    matInput
    [attr.autocomplete]="type == 'email' ? 'username' : null"
    [type]="type"
    [disabled]="disabled"
    [step]="step"
    [min]="min"
    [max]="max"
    [placeholder]="placeholderKey | locLabel"
    [readonly]="readonly"
    [(ngModel)]="value"
    (blur)="onTouch()"
  />

  <textarea
    #inputArea
    *ngIf="type === 'textarea'"
    matInput
    [type]="type"
    [disabled]="disabled"
    [placeholder]="placeholderKey | locLabel"
    [rows]="rows"
    [(ngModel)]="value"
    (blur)="onTouch()"
  ></textarea>

  <span *ngIf="suffix" matSuffix>{{ suffix }}</span>
</mat-form-field>
<app-input-footer
  *ngIf="footer"
  [hint]="max && type != 'number' ? (value?.length ?? 0) + ' / ' + max : null"
  [control]="ngControl?.control"
></app-input-footer>
